module.exports = __webpack_public_path__ + "img/down.0c099ff3.svg";